/*
 * Tulus brand tokens, from the Tulus brand guidelines (October 2026):
 * master PDF in acture-vision/incoming/reference/tulus-brand/, developer
 * digest in the tulus-mobile repo's doc/branding.md.
 *
 * The guide's own colours are used as given. Two shades are derived here,
 * because the guide warns that cyan and its muted grey must be checked for
 * contrast, and they fail WCAG AA for small text on white (cyan 3.14:1,
 * muted grey 4.19:1). The derived shades keep the guide's hue and pass:
 *   cyanText #0577A6  5.0:1 on paper, 4.52:1 on header mist
 *   mutedText #6B7079 4.98:1 on paper, 4.5:1 on header mist
 * Use `cyan` for icons, markers and large display; `cyanText` for any text,
 * links and button fills that carry white text.
 */
export const TULUS = {
  cyan: "#079BD7", // Tulus cyan: service icons, section markers
  cyanText: "#0577A6", // derived: text-safe Tulus cyan
  mist: "#E7F6FC", // header mist: welcoming header, soft surfaces
  ink: "#171A20", // headings, primary text
  paper: "#FFFFFF", // cards, reading surfaces
  muted: "#777C85", // muted grey: large supporting copy only
  mutedText: "#6B7079", // derived: text-safe muted grey for small copy
  linkCyan: "#5EC3F8", // carousel dots and decoration only (1.97:1)
  cream: "#FFEBCC", // prayer cream (approximate): a small warm accent
  line: "rgba(23, 26, 32, 0.10)", // fine borders
  shadow: "0 4px 16px rgba(23, 26, 32, 0.06)", // soft card shadow
} as const;

/* Card recipe from the guide: white, 18 px radius, a fine border, a soft shadow. */
export const tulusCard = {
  backgroundColor: TULUS.paper,
  border: `1px solid ${TULUS.line}`,
  borderRadius: "18px",
  boxShadow: TULUS.shadow,
} as const;
